export default __webpack_public_path__ + "static/media/Rocket.85e3c28d.webp";